module.exports = __webpack_public_path__ + "ec1ec422fd5ac1515437684af48ecba4.svg";